"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var generate_1 = require("./generate");
exports.generateSchema = generate_1.generateSchema;
var InputType_1 = require("./fields/InputType");
exports.InputType = InputType_1.InputType;
var Form_1 = require("./decorators/form/Form");
exports.Form = Form_1.default;
var Input_1 = require("./decorators/input/Input");
exports.Input = Input_1.default;
var FieldWrapper_1 = require("./fields/FieldWrapper");
exports.register = FieldWrapper_1.registerExternal;
exports.FieldWrapper = FieldWrapper_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/decorator-form/dist/index.js
// module id = 3
// module chunks = 0